<template>
  <div>
    <div class="text-center depahead rsu">Login</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <vue-element-loading :active="loading" spinner="bar-fade-scale" is-full-screen color="#152d51" />
      <v-container>
        <v-layout justify-center class="mt-5">
          <div class="d-flex flex-column col-12 col-sm-6">
            <h4 class="flex-all-center">กู้คืนรหัสผ่าน</h4>
            <div class="mt-5 col-12">
              <div class="mb-3">อีเมล หรือ เบอร์โทรศัพท์</div>

              <input v-model="email" type="text" class="form-control cus-input-search radius-40 " />
              <v-btn class="col-12 mt-5" @click="sendMail" color="#fbdd00">Send</v-btn>
              <v-btn class="col-12 mt-3" color="primary" @click="back('login')">BACK TO SIGN IN</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";
import config from "@/config";
import axios from "axios";

export default {
  components: {
    VueElementLoading,
  },
  props: {},
  data() {
    return {
      regisLineUrl: "https://line.me/R/ti/p/@446itcdh",
      loading: false,
      email: "",
    };
  },
  methods: {
    back() {
      this.$store.dispatch("setview", "Login");
    },
    async sendMail() {
      this.loading = true;
      const headers = {
        Authorization: `Bearer xxx xxx`,
      };
      let url = config.serverUrl + "sendmailforgetpassword";
      let res;
      try {
        let resCode = await axios.post(url, { email: this.email }, { headers });
        if (resCode.data.responsecode) {
          res = resCode.data.responsecode;
        }
      } catch (error) {
        console.error(error);
      }
      if (res == 204) {
        this.loading = false;
        await this.$swal.fire({
          type: "success",
          text: "ส่งลิงค์สำหรับรีเซ็ตพาสเวิร์ดเรียบร้อย",
          icon: "success",
          confirmButtonText: "ตกลง",
        });
        this.$store.dispatch("setview", "Login");
      } else {
        this.loading = false;
        this.$swal.fire({
          type: "warning",
          text: "ส่งอีเมลไม่สำเร็จ",
          icon: "warning",
          confirmButtonText: "ตกลง",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
